module.exports = __webpack_public_path__ + "img/cooperative0_logo23.a9a383c8.jpg";